import { Button,Menu,MenuItem } from "@mui/material";
import { blue } from "@mui/material/colors";
import React from "react";
import { useNavigate } from "react-router-dom";
function SimpleMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();


  function handleClick(event) {
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleNavigate(path) {
    navigate(path);
    handleClose();
  }

  return (
        <div style={{color: blue}}>
        <Button
            aria-owns={anchorEl ? "simple-menu" : undefined}
            aria-haspopup="true"
            onClick={handleClick}
            onMouseOver={handleClick}
        >
            <h3>
                Games
            </h3>
        </Button>
        <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            MenuListProps={{ onMouseLeave: handleClose }}
            PaperProps={{
                style: {
                minWidth: 200,
                },
            }}
        >
            <MenuItem onClick={() => handleNavigate("/MOTK")}>Mark Of The Knights</MenuItem>
            <MenuItem onClick={() => handleNavigate("/")}>Mark Of The Knights2</MenuItem>
        </Menu>
        </div>
  );
}

export default SimpleMenu;